/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/contacts_medium'
export default icon
